import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Space, Tooltip } from "antd";

interface Labels {
    approve?: string;
    reject?: string;
}

interface Props {
    state: string;
    pendingValue?: string;
    approvedValue: string;
    rejectedValue: string;
    onApprove: () => void;
    onReject: () => void;
    loading?: boolean;
    labels?: Labels;
    className?: string;
    hideApprove?: boolean;
}

export const ApproveRejectButtons: React.FC<Props> = ({
    state,
    pendingValue = "pending",
    approvedValue,
    rejectedValue,
    onApprove,
    onReject,
    loading,
    labels,
    className,
    hideApprove = false,
}) => {
    const isApproved = state === approvedValue;
    const isRejected = state === rejectedValue;
    const isPending = state === pendingValue;

    const baseBtn = "!border-none !shadow-none !p-0 !h-7 !w-7 flex items-center justify-center rounded-md text-white";

    return (
        <Space size={8} className={`justify-center ${className ?? ""}`}>
            {!hideApprove && (
                <Tooltip title={labels?.approve ?? "Approve"}>
                    <Button
                        type="primary"
                        size="small"
                        icon={<CheckOutlined />}
                        className={`${baseBtn} ${
                            isPending ? "!bg-emerald-500 hover:!bg-emerald-600" : "!bg-emerald-300 cursor-not-allowed"
                        }`}
                        onClick={onApprove}
                        disabled={loading || isApproved || !isPending}
                    />
                </Tooltip>
            )}

            <Tooltip title={labels?.reject ?? "Reject"}>
                <Button
                    type="primary"
                    size="small"
                    icon={<CloseOutlined />}
                    className={`${baseBtn} ${
                        isPending ? "!bg-rose-500 hover:!bg-rose-600" : "!bg-rose-300 cursor-not-allowed"
                    }`}
                    onClick={onReject}
                    disabled={loading || isRejected || !isPending}
                />
            </Tooltip>
        </Space>
    );
};
